export var localeData = {
    'en-US': {
        NAVBAR_DASHBOARD: 'Dashboard',
        NAVBAR_FLOW_MANAGER: 'Model',
        NAVBAR_IMPORT: 'Import',
        NAVBAR_REPORTS: 'Reports',
        NAVBAR_QA: 'QA',
        Configuration: 'Configuration',
        'Advanced administration': 'Advanced administration',
        'Cluster and flow': 'Cluster and flow',
        'Folder and document': 'Folder and document',
        Tags: 'Tags',
        'Users & Permissions': 'Users & Permissions',
        'Users & Groups': 'Users & Groups',
        'Cluster and flow permissions': 'Cluster and flow permissions',
        'Folder and document permissions': 'Folder and document permissions',
        System: 'System',
        'Input setup & Maintenance': 'Input setup & Maintenance',
        'Import data': 'Import data',
        'Input locking': 'Input locking',
        AKD: 'AKD',
        'Dynamic Form Inputs (Advanced)': 'Dynamic Form Inputs (Advanced)',
        'Feature Flags': 'Feature Flags',
        'Help Center': 'Help Center',
        'Contact Support': 'Contact Support',
        Support: 'Support',
        'My Account': 'My Account',
        'Sign out': 'Sign out',
        'No row selected': 'No row selected',
        'Select a cluster': 'Select a cluster',
        'Create new cluster': 'Create new cluster',
        'Add new flow': 'Add new flow',
        'Edit selection': 'Edit selection',
        'Delete selection': 'Delete selection',
        'Additional options': 'Additional options',
        Export: 'Export',
        Import: 'Import',
        Configure: 'Configure',
        Finish: 'Finish',
        'Configure job options': 'Configure job options',
        'Handle missing tags': 'Handle missing tags',
        Disallow: 'Disallow',
        'Skip row': 'Skip row',
        'Will not allow import as long as there are missing tags.': 'Will not allow import as long as there are missing tags.',
        'Will skip rows with missing tags.': 'Will skip rows with missing tags.',
        'Will import rows without missing tags.': 'Will import rows without missing tags.',
        'Import zeros': 'Import zeros',
        'Apply tags to value columns': 'Apply tags to value columns',
        'Add missing tags': 'Add missing tags',
        'View Options': 'View Options',
        'Finder view options': 'Finder view options',
        'Show reference numbers': 'Show reference numbers',
        'Reference numbers:': 'Reference numbers:',
        "You don't have access to the referenced flow, so you can't delete it.": "You don't have access to the referenced flow, so you can't delete it.-",
        'Referenced flows': 'Referenced flows',
        'Do you really want to delete flow': 'Do you really want to delete flow',
        'Confirm delete operation on flow': 'Confirm delete operation on flow',
        'Do you really want to delete cluster': 'Želite li stvarno izbrisati cluster',
        'and all its subclusters and items?': 'and all its subclusters and items?',
        'Confirm delete operation on cluster': 'Confirm delete operation on cluster',
        Cluster: 'Cluster',
        'is copying. You will be notified when it finishes.': 'is copying. You will be notified when it finishes.',
        'You must enter a title for the cluster': 'You must enter a title for the cluster',
        'Duplicate cluster': 'Duplicate cluster',
        'The data you are trying to copy is too big and can only be safely copied in': 'The data you are trying to copy is too big and can only be safely copied in',
        'Maintenance mode': 'Maintenance mode',
        'Copy tags': 'Copy tags',
        'Copy data': 'Copy data',
        'Duplicate to': 'Duplicate to',
        DUPLICATE_CLUSTER_COPY_DATA_HELP: 'If any of the flows in the hierarchy branch you are trying to duplicate have expression references to a flow outside of that branch, some duplicated flows still may contain data, whether or not you choose to copy it.',
        DUPLICATE_CLUSTER_COPY_DATA_HELP_MIRROR_MODE: 'Use source cluster as a template for the duplicate. This means, that any change in source cluster would be mirrored in to the duplicated one. Subclusters, flows, tags, formulas etc..',
        'You must enter a title for the flow': 'You must enter a title for the flow',
        DUPLICATE_FLOW_COPY_DATA_HELP_MIRROR_MODE: 'Changes in title, expression or tags in source flow, will be mirrored to the duplicated copy. Data itself will remain unaffected.',
        'New cluster': 'New cluster',
        'This reference is already taken. It should be unique.': 'This reference is already taken. It should be unique.',
        'No template': 'No template',
        'Editing flow': 'Editing flow',
        'New flow': 'Novi flow',
        'You must provide a title for the flow': 'You must provide a title for the flow',
        'Edit tag': 'Edit tag',
        'Create tag': 'Create tag',
        'You must enter a name for the tag': 'You must enter a name for the tag',
        "Tag name can't contain quotation marks.": "Tag name can't contain quotation marks.",
        'KPI not found': 'KPI not found',
        'Increase/decrease selections value by a percentage': 'Increase/decrease selections value by a percentage',
        'Apply selection value on next # of periods': 'Apply selection value on next # of periods',
        'Set same value to selected cells': 'Set same value to selected cells',
        'Press enter to apply': 'Press enter to apply',
        'Apply %': 'Apply %',
        'Copy #': 'Copy #',
        'Set #': 'Set #',
        Upload: 'Upload',
        Cancel: 'Cancel',
        Close: 'Close',
        Save: 'Save',
        Edit: 'Edit',
        Duplicate: 'Duplicate',
        Delete: 'Delete',
        Remove: 'Remove',
        Move: 'Move',
        'Move to': 'Move to',
        Yes: 'Yes',
        No: 'No',
        Title: 'Title',
        Enable: 'Enable',
        Disable: 'Disable',
        Inherited: 'Inherited',
        Confirm: 'Confirm',
        Reference: 'Reference',
        Parent: 'Parent',
        Model: 'Model',
        Template: 'Template',
        Owner: 'Owner',
        Description: 'Description',
        'Rollup type': 'Rollup type',
        Root: 'Root',
        Name: 'Name',
        Hidden: 'Hidden',
        Options: 'Options',
        Flat: 'Flat',
        Filter: 'Filter',
        Default: 'Default',
        Years: 'Years',
        Formatting: 'Formatting',
        Variations: 'Versions',
        Undo: 'Undo',
        Redo: 'Redo',
        Round: 'Round',
        Regression: 'Regression',
        flow: 'flow',
        cluster: 'cluster',
        function: 'function',
        variable: 'variable',
        constant: 'constant',
        tag: 'tag',
        Type: 'Type',
        Example: 'Example',
        'Impact type': 'Impact type',
        Path: 'Path',
        'Parent title': 'Parent title',
        Saved: 'Saved',
        'Formula error': 'Formula error',
        'Add new List item': 'Add new List item',
        Search: 'Search',
        'Visible columns': 'Visible columns',
        'Show location': 'Show location',
        'Sort by': 'Sort by',
        Date: 'Date',
        Page: 'Page',
        'Edit entry': 'Edit entry',
        'New entry by date': 'New entry by date',
        Enabled: 'Enabled',
        'Please enter at least one value.': 'Please enter at least one value.',
        'Add tag': 'Add tag',
        'Add new tag': 'Add new tag',
        'Inherited from cluster': 'Inherited from cluster',
        'Connected tag': 'Connected tag',
        'Set filter tag': 'Set filter tag',
        'Delete list item': 'Delete list item',
        'Are you sure you want to delete this list item?': 'Are you sure you want to delete this list item?',
        'Loading data...': 'Loading data...',
        'Flow link': 'Flow link',
        Actions: 'Actions',
        Sum: 'Sum',
        Average: 'Average',
        State: 'State',
        Short: 'Short',
        'Two decimals': 'Two decimals',
        'Whole numbers': 'Whole numbers',
        Thousands: 'Thousands',
        Dashboard: 'Dashboard',
        'Add Tile': 'Add Tile',
        'Toggle edit mode': 'Toggle edit mode',
        'Add Column': 'Add Column',
        'New Column': 'New Column',
        'Edit Tile': 'Edit Tile',
        'Delete Tile': 'Delete Tile',
        'Selecting report for': 'Selecting report for',
        "Couldn't find grid for report": "Couldn't find grid for report",
        'Report already has slicer': 'Report already has slicer',
        Print: 'Print',
        'Download PNG image': 'Download PNG image',
        'Download JPEG image': 'Download JPEG image',
        'Download SVG vector image': 'Download SVG vector image',
        'Enter header': 'Enter header',
        'Enter subheader': 'Enter subheader',
        Editing: 'Editing',
        'Create new': 'Create new',
        'You must enter a title for the chart': 'You must enter a title for the chart',
        'You must select a cluster': 'You must select a cluster',
        'You must add at least one chart line.': 'You must add at least one chart line.',
        'You must enter an expression.': 'You must enter an expression.',
        'Invalid expression.': 'Invalid expression.',
        'Period type': 'Period type',
        'Tile type': 'Tile type',
        'X axis': 'X axis',
        'Chart components configuration': 'Chart components configuration',
        'Select cluster': 'Select cluster',
        'Time period': 'Time period',
        'Add new chart component': 'Add new chart component',
        Value: 'Value',
        Scenario: 'Scenario',
        'Interval start': 'Interval start',
        'Interval end': 'Interval end',
        Variation: 'Variation',
        Format: 'Format',
        Expression: 'Expression',
        'Sim mode': 'Sim mode',
        'Sim variation': 'Sim variation',
        'Sim value': 'Sim value',
        Min: 'Min',
        Max: 'Max',
        Step: 'Step',
        'Source cluster': 'Source cluster',
        'Destination cluster': 'Destination cluster',
        Regular: 'Regular',
        Calculated: 'Calculated',
        'Header cannot be empty': 'Header cannot be empty',
        'You must choose a field type': 'You must choose a field type',
        'You must choose a format': 'You must choose a format',
        'Calculation fields cannot be empty': 'Calculation fields cannot be empty',
        'Invalid range chosen': 'Invalid range chosen',
        'Edit column': 'Edit column',
        Header: 'Header',
        'Enter header title': 'Enter header title',
        Subheader: 'Subheader',
        'Enter subheader title': 'Enter subheader title',
        'Field type': 'Field type',
        'Enter field type': 'Enter field type',
        'Enter format': 'Enter format',
        'Enter type': 'Enter type',
        'Conditional formatting': 'Conditional formatting',
        'Enter conditional formatting': 'Enter conditional formatting',
        'Hide numbers': 'Hide numbers',
        'Column 1': 'Column 1',
        'Column 2': 'Column 2',
        Operation: 'Operation',
        'Export template': 'Export template',
        'Shared Column Config Preset': 'Shared Column Config Preset',
        'Show zero sum rows': 'Show zero sum rows',
        'Use data from timeline slicer': 'Use data from timeline slicer',
        'Use data from dimension slicers': 'Use data from tag slicer(s)',
        'Using shared column config': 'Using shared column config',
        'Slicer generated': 'Slicer generated',
        'Create new chart component': 'Create new chart component',
        'Editing chart component': 'Editing chart component',
        'Please enter title for the chart line.': 'Please enter title for the chart line.',
        'Please select at least one account tag.': 'Please select at least one account tag.',
        'Please select flow.': 'Please select flow.',
        'Please select cluster.': 'Please select cluster.',
        'You must enter an expression for the chart line.': 'You must enter an expression for the chart line.',
        'Component title': 'Component title',
        Color: 'Color',
        'Chart type': 'Chart type',
        'Positive/Negative': 'Positive/Negative',
        Positive: 'Positive',
        Negative: 'Negative',
        'Data type': 'Data type',
        Flow: 'Flow',
        Stacked: 'Stacked',
        'Stacked editor': 'Stacked editor',
        KPI: 'KPI',
        Chart: 'Chart',
        'Single value': 'Single value',
        Simulation: 'Simulation',
        Absolute: 'Absolute',
        'Relative Multiply': 'Relative Multiply',
        'Relative Add': 'Relative Add',
        Off: 'Off',
        'Traffic lights': 'Traffic lights',
        'Data bar': 'Data bar',
        'Color scale': 'Color scale',
        'Arrow up and down': 'Arrow up and down',
        Relative: 'Relative',
        month: 'month',
        quarter: 'quarter',
        halfyear: 'halfyear',
        year: 'year',
        Line: 'Line',
        Bar: 'Bar',
        Area: 'Area',
        None: 'None',
        formatted: 'formatted',
        unformatted: 'unformatted',
        whole: 'whole',
        thousands: 'thousands',
        minus: 'minus',
        divide: 'divide',
        plus: 'plus',
        multiply: 'multiply',
        percent: 'percent',
        'percent thousands': 'percent thousands',
        'difference in %': 'difference in %',
        'Report elements': 'Report elements',
        'Type to add new row': '',
        'Users management': 'Users management',
        'User groups management': 'User groups management',
        'Delete data for': 'Delete data for',
        'Delete children of': 'Delete children of',
        'and related data': 'and related data',
        'has related data': 'has related data',
        'Are you sure you want to delete': 'Are you sure you want to delete',
        'Import new': 'Import new',
        'Download file': 'Download file',
        'this import job': 'this import job',
        'Create User': 'Create User',
        'Delete User by ID': 'Delete User by ID',
        'Find All Users': 'Find All Users',
        'Get User by ID': 'Get User by ID',
        'Update User': 'Update User',
        'CLASS PERMISSIONS': 'CLASS PERMISSIONS',
        'Tag Editor': 'Tag Editor',
        'Cluster Flow Add': 'Cluster Flow Add',
        'Administration Menu': 'Administration Menu',
        'Internal Config Options': 'Internal Config Options',
        'Version & Year Locks': 'Version & Year Locks',
        'Remote Jobs': 'Remote Jobs',
        'FEATURE PERMISSIONS': 'FEATURE PERMISSIONS',
        'Create Tag': 'Create Tag',
        'Delete Tag by ID': 'Delete Tag by ID',
        'Find All Tags': 'Find All Tags',
        'Get Tag by ID': 'Get Tag by ID',
        'Update Tag': 'Update Tag',
        'Create Cluster': 'Create Cluster',
        'Delete Cluster by ID': 'Delete Cluster by ID',
        'Duplicate Cluster': 'Duplicate Cluster',
        'Find All Clusters': 'Find All Clusters',
        'Get Cluster by ID': 'Get Cluster by ID',
        'Update Cluster': 'Update Cluster',
        'Create Document': 'Create Document',
        'Delete Document by ID': 'Delete Document by ID',
        'Duplicate Document': 'Duplicate Document',
        'Find All Documents': 'Find All Documents',
        'Get Document by ID': 'Get Document by ID',
        'Update Document': 'Update Document',
        MAINTENANCE_INFO: 'Maintenance mode is used when you need to prevent other Users from accessing Farseer while making critical changes in the system. While maintenance mode is on, Users will be notified about it, and they will be unable to log back in to Farseer until it is off.',
        // DRAG & DROP MESSAGES
        'Not implemented yet': 'Not implemented yet',
        'Cluster not found': 'Cluster not found',
        'Parent cluster not found': 'Parent cluster not found',
        "Flows aren't allowed to have children": "Flows aren't allowed to have children",
        "Flows aren't allowed to be children of root": "Flows aren't allowed to be children of root",
        'Tag not found': 'Tag not found',
        'Failed creating cluster': 'Failed creating cluster',
        'Cluster created': 'Cluster created',
        'Widget not found': 'Widget not found',
        'Variable field should contain account tags': 'Variable field should contain account tags',
        'Filter field should contain dimension tags': 'Filter field should contain dimension tags',
        'Comparison field should contain dimension tags': 'Comparison field should contain dimension tags',
        'Column field should contain table or dimension tags': 'Column field should contain table or dimension tags',
        'Row field should contain table or dimension tags': 'Row field should contain table or dimension tags',
        'Unknown zone in single value': 'Unknown zone in single value',
        'Unknown zone in data editor': 'Unknown zone in data editor',
        'Disabled': 'Disabled',
        'Before': 'Before',
        'After': 'After',
        'Show Value': 'Show Value',
        'Show Variables and Dimensions': 'Show Variables and Dimensions',
        'Hide Gridlines': 'Hide Gridlines',
        'Labels': 'Labels',
        'Name and Description': 'Name and Description',
        'Subtotals': 'Subtotals',
        'Freeze Rows/Columns': 'Freeze Rows/Columns',
    },
    'hr-HR': {
        NAVBAR_DASHBOARD: 'Nadzorna Ploča',
        NAVBAR_FLOW_MANAGER: 'Model',
        NAVBAR_IMPORT: 'Import',
        NAVBAR_REPORTS: 'Izvještaji',
        NAVBAR_QA: 'QA',
        Configuration: 'Konfiguracija',
        'Advanced administration': 'Napredna administracija',
        'Cluster and flow': 'Cluster i Flow',
        'Folder and document': 'Folderi i dokumenti',
        'No row selected': 'Nema odabranog clustera',
        'Users & Permissions': 'Korisnici i Permisije',
        'Users & Groups': 'Korisnici i Grupe',
        'Cluster and flow permissions': 'Permisije za cluster i flow',
        'Folder and document permissions': 'Permisije za foldere i dokumente',
        System: 'Sustav',
        'Input setup & Maintenance': 'Održavanje',
        'Import data': 'Uvoz podataka',
        'Input locking': 'Zaključavanje unosa',
        AKD: 'AKD',
        'Dynamic Form Inputs (Advanced)': 'Dinamički Obrasci (Napredno)',
        'Feature Flags': 'Dodatne Funkcionalnosti',
        'My Profile': 'Moj Profil',
        'Add Report': 'Dodaj Izvještaj',
        'Sign out': 'Odjava',
        Share: 'Podijeli',
        'Select a report': 'Odaberi izvještaj',
        View: 'Prikaz',
        Versions: 'Verzije',
        'Horizontal Versions': 'Vodoravne Verzije',
        'Vertical Versions': 'Okomite Verzije',
        Groups: 'Grupe',
        'Users & Groups Management': 'Upravljanje Korisnicima i Grupama',
        'Version & Year Locks': 'Zaključavanje Godina i Verzija',
        Comparison: 'Usporedi',
        'Edit Tag': 'Uredi tag',
        'All tags': 'Svi tagovi',
        'Manage columns': 'Upravljaj stupcima',
        'Exact match': 'Točno podudaranje',
        'Add List Item': 'Dodaj Linijsku Stavku',
        'Set Value': 'Postavi Vrijednost',
        'Apply Percentage': 'Primjeni Postotak',
        Percent: 'Postotak',
        Version: 'Verzija',
        Random: 'Nasumično',
        Action: 'Akcija',
        Active: 'Aktivan',
        Select: 'Odaberi',
        'Create User': 'Novi Korisnik',
        'Add as column': 'Dodaj stupac',
        'Add connection': 'Dodaj konekciju',
        'Create Group': 'Nova Grupa',
        'No cluster or flow selected': 'Nije odabran cluster ni flow',
        'Select a cluster': 'Odaberi cluster',
        'Add Cluster': 'Dodaj Cluster',
        'Add Flow': 'Dodaj Flow',
        'Master Cluster': 'Glavni Cluster',
        'Copy Left': 'Kopiraj Lijevo',
        'Copy Right': 'Kopiraj Desno',
        'Copy from previous year': 'Kopiraj iz prethodne godine',
        'Create new cluster': 'Stvori novi cluster',
        'Add new flow': 'Dodaj novi flow',
        'Edit selection': 'Uređivanje',
        'Delete selection': 'Izbriši odabir',
        'Additional options': 'Dodatne opcije',
        'Model Templates': 'Predlošci Modela',
        Export: 'Izvoz podataka',
        Import: 'Uvoz',
        Report: 'Izvještaj',
        Folder: 'Mapa',
        Copy: 'Kopiraj',
        Paste: 'Zalijepi',
        '12 Months': '12 Mjeseci',
        'Year End': 'Kraj Godine',
        'Year Start': 'Početak Godine',
        'Timeline Start': 'Početak Vremenskog Niza',
        'Timeline End': 'Kraj Vremenskog Niza',
        Configure: 'Konfiguracija',
        Finish: 'Završetak',
        'Configure job options': 'Postavi opcije',
        'Handle missing tags': 'Način obrade nepostojećih tagova',
        Disallow: 'Nemoj dozvoliti',
        'Skip row': 'Preskoči',
        'Will not allow import as long as there are missing tags.': 'Ne dozvoljava uvoz podataka dok postoje retci s tagovima koji ne postoje.',
        'Will skip rows with missing tags.': 'Preskače retke s nepostojećim tagovima.',
        'Will import rows without missing tags.': 'Uvozi podatke bez nepostojećih tagova.',
        'Import zeros': 'Uvoz nula',
        'Apply tags to value columns': 'Primijeni tagove na stupce s vrijednostima',
        'Add missing tags': 'Dodaj nepostojeće tagove',
        'View Options': 'Mogućnosti pregleda',
        'Finder view options': 'Mogućnosti prikaza findera',
        'Show reference numbers': 'Prikaži reference',
        'Reference numbers:': 'Reference:',
        "You don't have access to the referenced flow, so you can't delete it.": "You don't have access to the referenced flow, so you can't delete it.-",
        'Referenced flows': 'Referenced flows',
        'Do you really want to delete flow': 'Jeste li sigurni da želite izbrisati flow?',
        'Confirm delete operation on flow': 'Potvrdi brisanje flowa',
        'Do you really want to delete cluster': 'Jeste li sigurni da želite izbrisati cluster',
        'and all its subclusters and items?': 'i njegove pod clustere?',
        'Confirm delete operation on cluster': 'Potvrdi brisanje clustera',
        Cluster: 'Cluster',
        'is copying. You will be notified when it finishes.': 'is copying. You will be notified when it finishes.',
        'You must enter a title for the cluster': 'Morate unijeti naziv clustera',
        'Duplicate cluster': 'Duplikacija cluster',
        'The data you are trying to copy is too big and can only be safely copied in': 'The data you are trying to copy is too big and can only be safely copied in',
        'Maintenance mode': 'Održavanje aplikacije',
        'Copy tags': 'Kopiraj tagove',
        'Copy data': 'Kopiraj podatke',
        'Duplicate to': 'Dupliciraj u',
        DUPLICATE_CLUSTER_COPY_DATA_HELP: 'If any of the flows in the hierarchy branch you are trying to duplicate have expression references to a flow outside of that branch, some duplicated flows still may contain data, whether or not you choose to copy it.',
        DUPLICATE_CLUSTER_COPY_DATA_HELP_MIRROR_MODE: 'Use source cluster as a template for the duplicate. This means, that any change in source cluster would be mirrored in to the duplicated one. Subclusters, flows, tags, formulas etc..',
        'You must enter a title for the flow': 'Morate unijeti naziv za flow',
        DUPLICATE_FLOW_COPY_DATA_HELP_MIRROR_MODE: 'Changes in title, expression or tags in source flow, will be mirrored to the duplicated copy. Data itself will remain unaffected.',
        'New cluster': 'Novi cluster',
        'This reference is already taken. It should be unique.': 'This reference is already taken. It should be unique.',
        'No template': 'Nema predloška',
        'Editing flow': 'Uređivanje flowa',
        'New flow': 'Novi flow',
        'You must provide a title for the flow': 'Morate upisati naziv flowa',
        'Edit tag': 'Uređivanje taga',
        'Create tag': 'Stvori tag',
        'You must enter a name for the tag': 'Morate unijeti naziv taga',
        "Tag name can't contain quotation marks.": "Tag name can't contain quotation marks.",
        'Flow name': 'Naziv flowa',
        'Add flows': 'Dodaj flowove',
        'Add another flow': 'Dodaj još jedan flow',
        'KPI not found': 'KPI nije pronađen',
        'Increase/decrease selections value by a percentage': 'Povećaj ili smanji odabrane vrijednosti za postotak',
        'Apply selection value on next # of periods': 'Povećaj/smanji za postotak',
        'Set same value to selected cells': 'Postavi istu vrijednost za sve ćelije',
        'Press enter to apply': 'Pritisni enter za potvrdu',
        'Apply %': 'Dodaj %',
        'Copy #': 'Kopiraj #',
        'Set #': 'Postavi #',
        'Column type': 'Tip kolone',
        'Select all': 'Odaberi sve',
        'Welcome to Import.': 'Dobro došli u Uvoz.',
        'Drag your file here': 'Povucite svoju datoteku ovdje',
        'Import your spreadsheets from Excel right into Farseer and manage them.': 'Uvezite proračunske tablice iz programa Excel izravno u Farseer i upravljajte njima.',
        'New report': 'Novi izvještaj',
        'Editing report': 'Uređivanje izvještaja',
        'New document': 'Novi dokument',
        'Editing document': 'Uređivanje dokumenta',
        Editing: 'Uređivanje',
        Browse: 'Pregledaj',
        OR: 'ILI',
        'Column tags': 'Tagovi kolona',
        'Filter tags': 'Tagovi filtra',
        'Filter by': 'Filtriraj po',
        'X - Axis and Interval': 'X - Os i interval',
        'Export template': 'Predložak za izvoz',
        'Shared Column Config Preset': 'Dijeljena konfiguracija stupaca',
        'Show zero sum rows': 'Prikaz redaka nulte sume',
        'Use data from timeline slicer': 'Korištenje podataka slicera vremenske trake',
        'Use data from tag slicer(s)': 'Korištenje podataka tag slicera',
        'Using shared column config': 'Korištena dijeljena konfiguracija',
        'Slicer generated': 'Generirano sa slicerom',
        'Data editor': 'Uređivač podataka',
        'Multiple Select': 'Višestruki odabir',
        'Choose Individual Dimensions': 'Odabir pojedinačnih tag-ova',
        'Slicer tags': 'Tag-ovi slicera',
        'Create new chart': 'Stvaranje novog grafikona',
        'Create new single value': 'Stvaranje nove jedinstvene vrijednosti',
        'Create new timeline slicer': 'Stvaranje novog slicera vremenske trake',
        'Create new tag slicer': 'Stvaranje novog tag slicera',
        'Create New Variable': 'Stvori Novi Tag',
        'Version & Year locks': 'Zaključavanje verzija i godina',
        'Select version': 'Odaberi verziju',
        'Create new KPI': 'Stvaranje novog KPI-a',
        'Editing KPI': 'Uređivanje KPI-a',
        'Editing chart': 'Uređivanje grafikona',
        'Editing timeline slicer': 'Uređivanje slicera vremenske trake',
        'Editing tag slicer': 'Uređivanje tag slicera',
        'Editing data editor': 'Uređivanje uređivača podataka',
        'Editing single value': 'Uređivanje jedne vrijednosti',
        'Button controls': 'Kontrole gumba',
        'Font size': 'Veličina fonta',
        'Only With Data': 'Isključivo s Podacima',
        'Enter formula here': 'Unesite formulu ovdje',
        'Historical Data From': 'Povijesni podaci od',
        'Historical Data To': 'Povijesni podaci do',
        'End date must be greater than start date': 'Krajnji datum mora biti veći od početnog',
        'Source Tags': 'Izvorni tagovi',
        'New custom column': 'Nova prilagođena kolona',
        'Search for imports': 'Traženje uvoza',
        'Previous Imports': 'Prethodni uvozi',
        'Previous imports': 'Prethodni uvozi',
        'Connected tags': 'Povezani tagovi',
        'Dimension tags': 'Dimension tagovi',
        'Delete tag data': 'Izbriši podatake taga',
        'Delete Tag': 'Izbriši tag',
        'Format type': 'Tip formata',
        'Top down enabled': 'Omogući top down',
        'Enter custom format': 'Unesite prilagođeni format',
        'Global formatting': 'Globalno formatiranje',
        'Closing state': 'Završno stanje',
        'Beginning state': 'Početno stanje',
        'Add connected tag': 'Dodajte povezani tag',
        'Add dimension tag': 'Dodajte dimension tag',
        'Share Tag': 'Podijeli tag',
        'First Name': 'Ime',
        'Last Name': 'Prezime',
        'Confirm Password': 'Potvrdi lozinku',
        'Input Setup': 'Podešavanje Ulaza',
        'Added By': 'Dodao/la',
        'Data management': 'Upravljanje podatcima',
        'Data Management': 'Upravljanje podatcima',
        'Copy data from source': 'Kopiranje podataka iz izvora',
        'Select source': 'Odabir izvora',
        'Name & Color': 'Naziv',
        'Add Version': 'Dodaj verziju',
        'Choose job to replace': 'Odaberite posao za zamjenu',
        'Thousands (Two Decimals)': 'Tisuće (Dvije Decimale)',
        'Thousands (Whole Numbers)': 'Tisuće (Cijeli Brojevi)',
        'Refresh data': 'Osvježi podatke',
        'Add Comment': 'Dodaj komentar',
        'Comments': 'Komentari',
        'Add comment or tag others with @...': 'Komentiraj ili označi druge s @...',
        'Reply or tag others with @...': 'Odgovori ili označi druge s @...',
        'My Account': 'Moj račun',
        'Sign Out': 'Odjavi se',
        'IN PROGRESS': 'U TIJEKU',
        'Advanced filter': 'Npredni filter',
        'Add new column': 'Dodavanje nove kolone',
        'Application Version': 'Verzija Aplikacije',
        'Chart color palette': 'Paleta boja grafikona',
        'Tag description': 'Opis taga',
        'Value for month': 'Vrijednost za mjesec',
        'Custom field': 'Prilagođeno polje',
        'Manual mapping': 'Ručno mapiranje',
        'Database': 'Baza podataka',
        'New Row': 'Novi redak',
        'Lock Row': 'Zaključaj redak',
        'More Options': 'Dodatne postavke',
        'Lock Hierarchy': 'Zaklj. hijerarhiju',
        'Unlock Hierarchy': 'Otklj. hijerarhiju',
        'Create Entry Link': 'Novi link za unos',
        'Entry Links': 'Linkovi za unos',
        Clear: 'Očisti',
        Autodetect: 'Automatsko otkrivanje',
        Month: 'Mjesec',
        Unmapped: 'Nemapirano',
        Croatian: 'Hrvatski',
        English: 'Engleski',
        and: 'i',
        Locks: 'Zaključavanje',
        COMPLETED: 'DOVRŠENO',
        REVIEW: 'PREGLED',
        Tasks: 'Zadatci',
        Integer: 'Cijeli broj',
        Decimal: 'Decimalni broj',
        Date: 'Datum',
        Custom: 'Prilagođeni',
        Number: 'Broj',
        Currency: 'Valuta',
        Percentage: 'Postotak',
        Add: 'Dodaj',
        Remove: 'Odstrani',
        Move: 'Preseli',
        'Move to': 'Preseli u',
        Forecast: 'Predvidi',
        Tags: 'Tagovi',
        Readonly: 'Samo za čitanje',
        Transpose: 'Transponiraj',
        Columns: 'Kolone',
        Upload: 'Prenesi',
        Archive: 'Arhiviraj',
        Replace: 'Nadomjesti',
        Connect: 'Poveži',
        Disconnect: 'Odvoji',
        Advanced: 'Napredno',
        Cancel: 'Odustani',
        Close: 'Zatvori',
        Save: 'Spremi',
        Edit: 'Uredi',
        Duplicate: 'Dupliciraj',
        Delete: 'Izbriši',
        Yes: 'Da',
        No: 'Ne',
        Title: 'Naziv',
        Enable: 'Omogući',
        Disable: 'Onemogući',
        Inherited: 'Nasljeđeno',
        Confirm: 'Potvrda',
        Reference: 'Referenca',
        Parent: 'Nadređeni',
        Model: 'Model',
        Template: 'Predložak',
        Owner: 'Vlasnik',
        Description: 'Opis',
        'Rollup type': 'Tip akumuliranja',
        Root: 'Ishodište modela',
        Name: 'Naziv',
        Hidden: 'Skriveno',
        Options: 'Opcije',
        Flat: 'Flat',
        Filter: 'Filtar',
        Default: 'Tablica',
        Years: 'Godine',
        Formatting: 'Format',
        Variations: 'Verzije',
        Undo: 'Undo',
        Redo: 'Redo',
        Round: 'Zaokruži',
        Regression: 'Interpolacija',
        flow: 'flow',
        cluster: 'cluster',
        function: 'funkcija',
        variable: 'varijabla',
        'KPI line': 'KPI linija',
        constant: 'konstanta',
        tag: 'tag',
        Type: 'Tip',
        Example: 'Primjer',
        'Impact type': 'Impact type',
        Path: 'Putanja',
        'Parent title': 'Naziv',
        Saved: 'Spremljeno',
        'Formula error': 'Greška u formuli',
        'Add new List item': 'Dodaj novu stavku',
        Search: 'Pretraga',
        'Visible columns': 'Vidljive kolone',
        'Show location': 'Prikaži lokaciju',
        'Sort by': 'Sortiraj',
        Page: 'Stranica',
        'Edit entry': 'Uređivanje',
        'New entry by date': 'Novo',
        Enabled: 'Omogućeno',
        'Please enter at least one value.': 'Molimo unesite bar jednu vrijednost.',
        'Add Tag': 'Dodaj Tag',
        'Add New Tag': 'Dodaj Novi Tag',
        'Inherited from cluster': 'Nasljeđeno od cluster',
        'Connected tag': 'Spojeni tag',
        'Set filter tag': 'Postavi tag za filtriranje',
        'Delete list item': 'Izbriši stavku',
        'Are you sure you want to delete this list item?': 'Jeste li sigurni da želite izbrisati stavku?',
        'Loading data...': 'Učitavanje podataka...',
        'Flow link': 'Link na flow',
        Actions: 'Akcije',
        Sum: 'Zbroj',
        Average: 'Prosjek',
        State: 'Stanje',
        Short: 'Skraćeni format',
        'Two Decimals': 'Dvije Decimale',
        'Whole Numbers': 'Cijeli Brojevi',
        Thousands: 'Tisuće',
        Dashboard: 'Nadzorna Ploča',
        'Toggle edit mode': 'Uređivanje',
        'Add Tile': 'Dodaj element',
        'Add Column': 'Dodaj kolonu',
        'New Column': 'Nova kolona',
        'Edit Tile': 'Uredi element',
        'Delete Tile': 'Izbriši element',
        'Selecting report for': 'Biranje izvještaja za',
        "Couldn't find grid for report": 'Nije pronađen grid za izvještaj',
        'Report already has slicer': 'Izvještaj već ima slicer',
        Print: 'Print',
        'Download PNG image': 'Download PNG image',
        'Download JPEG image': 'Download JPEG image',
        'Download SVG vector image': 'Download SVG vector image',
        'Enter header': 'Unesi naslov',
        'Enter subheader': 'Unesi podnaslov',
        'Create new': 'Dodaj novi',
        'You must enter a title for the chart': 'Morate unijeti naslov grafa',
        'You must select a cluster': 'Morate odabrati cluster',
        'You must add at least one chart line.': 'Morate dodati bar jednu liniju grafa.',
        'You must enter an expression.': 'Morate unijeti formulu.',
        'Invalid formula.': 'Greška u formuli.',
        'Period type': 'Tip perioda',
        'Tile type': 'Tip elementa',
        'X axis': 'X os',
        'Chart components configuration': 'Konfiguracija grafa',
        'Select cluster': 'Odaberi cluster',
        'Time period': 'Vremenski period',
        'Add new chart component': 'Dodaj novu komponentu grafa',
        Value: 'Vrijednost',
        Scenario: 'Scenarij',
        'Interval start': 'Početak intervala',
        'Interval end': 'Kraj intervala',
        Variation: 'Verzija',
        Format: 'Format',
        Expression: 'Formula',
        'Sim mode': 'Sim mode',
        'Sim variation': 'Sim verzija',
        'Sim value': 'Sim vrijednost',
        Min: 'Min',
        Max: 'Max',
        Step: 'Korak',
        'Source cluster': 'Izvorišni cluster',
        'Destination cluster': 'Odredišni cluster',
        Regular: 'Normalna',
        Calculated: 'Izračunata',
        'Header cannot be empty': 'Naslov ne smije biti prazan',
        'You must choose a field type': 'Morate odabrati tip polja',
        'You must choose a format': 'Morate odabrati format',
        'Calculation fields cannot be empty': 'Calculation fields cannot be empty',
        'Invalid range chosen': 'Pogrešan vremenski raspon',
        'Edit column': 'Uredi kolonu',
        Header: 'Naslov',
        'Enter header title': 'Unesi naslov',
        Subheader: 'Podnaslov',
        'Enter subheader title': 'Unesi podnaslov',
        'Field type': 'Tip polja',
        'Enter field type': 'Unesi tip polja',
        'Enter format': 'Unesi format',
        'Enter type': 'Unesi tip',
        'Conditional formatting': 'Dodatno formatiranje',
        'Enter conditional formatting': 'Odaberi dodatno formatiranje',
        'Hide numbers': 'Sakrij brojeve',
        'Column 1': 'Kolona 1',
        'Column 2': 'Kolona 2',
        Operation: 'Operacija',
        'Create new chart component': 'Dodavanje nove komponente grafa',
        'Editing chart component': 'Uređivanje komponente grafa',
        'Please enter title for the chart line.': 'Molimo unesite naziv.',
        'Please select at least one account tag.': 'Molimo odaberite barem jednu "account" oznaku',
        'Please select flow.': 'Molimo odaberite flow.',
        'Please select cluster.': 'Molimo odaberite cluster.',
        'You must enter an expression for the chart line.': 'Morate unijeti formulu.',
        'Component title': 'Naslov',
        Color: 'Boja',
        'Chart type': 'Tip grafa',
        'Positive/Negative': 'Pozitivna/negativna',
        Positive: 'Pozitivna',
        Negative: 'Negativna',
        'Data type': 'Tip podataka',
        Flow: 'Flow',
        Stacked: 'Naslagano',
        'Stacked editor': 'Uređivanje naslaganih grafova',
        Chart: 'Graf',
        'Single value': 'Jedna vrijednost',
        Simulation: 'Simulacija',
        Absolute: 'Apsolutno',
        'Relative Multiply': 'Relativno množenje',
        'Relative Add': 'Relativno zbrajanje',
        Off: 'Isljučeno',
        On: 'Uključeno',
        'Traffic lights': 'Semafor',
        'Data bar': 'Stupci',
        'Color scale': 'Boja',
        'Arrow up and down': 'Strelice',
        Relative: 'Relativno',
        month: 'mjesec',
        quarter: 'kvartal',
        halfyear: 'polugodište',
        year: 'godina',
        Line: 'Linijski',
        Bar: 'Stupčasti',
        Area: 'Površinski',
        None: 'Nijedan',
        formatted: 'formatirano',
        Unformatted: 'Neformatirano',
        whole: 'cijeli',
        thousands: 'tisuće',
        minus: 'oduzimanje',
        divide: 'dijeljenje',
        plus: 'zbrajanje',
        multiply: 'množenje',
        percent: 'postotak',
        'percent thousands': 'postotak u tisućama',
        'difference in %': 'razlika u %',
        'Report elements': 'Izvještajni elementi',
        'Type to add new row': '',
        'Users management': 'Upravljanje korisnicima',
        'User groups management': 'Upravljanje korisničkim grupama',
        'Show all users': 'Prikaži sve korisnike',
        'Not member of a group': 'Koji nisu članovi grupe',
        'Member of one group': 'Članovi jedne grupe',
        'Member of more than one group': 'Članovi više od jedne grupe',
        'Create user': 'Dodaj korisnika',
        'Create new user': 'Dodavanje novog korisnika',
        'Sort by...': 'Sortiranje',
        'Sort by:': 'Sortiraj po:',
        Position: 'Pozicija',
        'Oldest first': 'Najstariji prvo',
        'Create group': 'Dodaj grupu',
        'Create new group': 'Dodavanje novih grupa',
        'Cluster and flow management': 'Upravljanje clusterima i flowovima',
        'Delete User by ID': 'Brisanje korisnika prema identifikacijskom broju',
        'Find All Users': 'Prikaz svih korisnika',
        'Get User by ID': 'Dohvat korisnika identifikacijskim brojem',
        'Update User': 'Osvježavanje podataka o korisniku',
        'CLASS PERMISSIONS': 'DOZVOLE NAD RAZREDIMA',
        'Tag Editor': 'Upravljanje tagovima',
        'Cluster Flow Add': 'Dodavanje clustera i flowova',
        'Administration Menu': 'Upravljački izbornik',
        'Internal Config Options': 'Interne postavke',
        'Remote Jobs': 'Udaljeni zadaci',
        'FEATURE PERMISSIONS': 'DOZVOLE NAD FUNKCIONALNOSTIMA',
        'Search for users...': 'Pretraži korisnike...',
        'Search for groups...': 'Pretraži grupe...',
        'Search for permissions...': 'Pretraži dozvole...',
        'Create Tag': 'Stvaranje tagova',
        'Delete Tag by ID': 'Brisanje tagova po identifikacijskom broju',
        'Find All Tags': 'Prikaz svih tagova',
        'Get Tag by ID': 'Dohvat taga identifikacijskim brojem',
        'Update Tag': 'Osvježavanje podataka o tagu',
        'Create Cluster': 'Stvaranje clustera',
        'Delete Cluster by ID': 'Brisanje dokumenata po identifikacijskom broju',
        'Duplicate Cluster': 'Dupliciranje clustera',
        'Find All Clusters': 'Prikaz svih clustera',
        'Get Cluster by ID': 'Dohvat clustera po identifikacijskom broju',
        'Update Cluster': 'Osvježavanje podataka o clusteru',
        'Create Document': 'Stvaranje dokumenata',
        'Delete Document by ID': 'Brisanje dokumenata po identifikacijskom broju',
        'Duplicate Document': 'Dupliciranje dokumenata',
        'Find All Documents': 'Prikaz svih dokumenata',
        'Get Document by ID': 'Dohvat dokumenata po identifikacijskom broju',
        'Update Document': 'Osvježavanje podataka o dokumentu',
        MAINTENANCE_INFO: 'Održavanje aplikacije se može aktivirati kad trebate isljučiti mogućnost prijave drugih korisnika na Farseer dok radite kritične izmjene u sustavu. Dok je održavanje uključeno, korisnici će biti obavješteni i neće se moći prijaviti na Farseer dok se održavanje ne isljuči.',
        'Hide replies': 'Sakrij odgovore',
        'Hide Reply': 'Sakrij odgovor',
        Replies: 'Odgovori',
        Reply: 'Odgovori',
        'Write something': 'Poruka',
        Submit: 'Pošalji',
        'Input setup': 'Podešavanje ulaza',
        'Available input variations': 'Dostupne verzije',
        'Add variation': 'Dodaj verziju',
        'First name': 'Ime',
        'Last name': 'Prezime',
        'Decimal separator': 'Decimalni razdjelnik',
        Settings: 'Postavke',
        Password: 'Lozinka',
        'New password': 'Nova zaporka',
        'Confirm new password': 'Potvrdi novu zaporku',
        'Change password': 'Promijeni zaporku',
        'My profile information': 'Moj profil',
        'App language': 'Jezik applikacije',
        variation: 'verziju',
        'Add new': 'Dodaj novu',
        'Variation name': 'Naziv verzije',
        From: 'Od',
        To: 'Do',
        January: 'Siječanj',
        Febuary: 'Veljača',
        March: 'Ožujak',
        April: 'Travanj',
        May: 'Svibanj',
        June: 'Lipanj',
        July: 'Srpanj',
        August: 'Kolovoz',
        September: 'Rujan',
        October: 'Listopad',
        November: 'Studeni',
        December: 'Prosinac',
        'Create new KPI table': 'Dodaj novu izvještajnu tablicu',
        'Custom expression': 'Formula',
        'Default format': 'Osnovni format',
        'Basic number': 'Bez formata',
        Home: 'Početna',
        'Create new folder': 'Dodaj novi folder',
        Reports: 'Izvještaji',
        'Edit current folder': 'Uredi odabrani folder',
        'Delete current folder': 'Izbriši odabrani folder',
        'Add new document': 'Dodaj novi dokument',
        'Edit selected document': 'Uredi odabrani dokument',
        'Delete selected document': 'Izbriši odabrani dokument',
        'Editing folder': 'Uređivanje foldera',
        'New folder': 'Novi folder',
        'Cluster and flow permissions management': 'Upravljanje permisijama',
        'Clusters & flows tree': 'Model',
        'Cluster tree': 'Hijerarhija',
        'User groups': 'Korisničke grupe',
        Users: 'Korisnici',
        permitted: 'Dozvoljeno',
        forbidden: 'Zabranjeno',
        inherited: 'Naslijeđeno',
        'Folder and document permissions management': 'Upravljanje permisijama',
        'Folders tree': 'Folderi',
        'Add year': 'Dodaj godinu',
        'Available years': 'Dostupne godine',
        'Select year': 'Odaberi godinu',
        'Delete data for': 'Izbrisati podatke za',
        'Delete children of': 'Izbrisati djecu od',
        'and related data': 'i povezane podatke',
        'has related data': 'ima povezanih podataka',
        'Are you sure you want to delete': 'Jeste li sigurni da želite izbrisati',
        'Import new': 'Novi uvoz',
        'Download file': 'Preuzmi datoteku',
        'this import job': 'ovaj uvoz',
        // DRAG & DROP MESSAGES
        'Not implemented yet': 'Još nije implementirano',
        'Cluster not found': 'Cluster nije pronađen',
        'Parent cluster not found': 'Parent cluster nije pronađen',
        "Flows aren't allowed to have children": 'Flowovi ne smiju imati djecu',
        "Flows aren't allowed to be children of root": 'Flowovi ne smiju biti u korijenu',
        'Tag not found': 'Tag nije pronađen',
        'Failed creating cluster': 'Nije uspjelo kreiranje clustera',
        'Cluster created': 'Cluster kreiran',
        'Widget not found': 'Widget nije pronađen',
        'Variable field should contain account tags': 'Polje varijabli bi trebalo sadržavati account tagove',
        'Filter field should contain dimension tags': 'Filter polje bi trebalo sadržavati dimenzije',
        'Comparison field should contain dimension tags': 'Polje usporedbe bi trebalo sadržavati dimenzije',
        'Column field should contain table or dimension tags': 'Polje stupca bi trebalo sadržavati tablice ili dimenzije',
        'Row field should contain table or dimension tags': 'Polje retka bi trebalo sadržavati tablice ili dimenzije',
        'Unknown zone in single value': 'Nepoznato polje',
        'Unknown zone in data editor': 'Nepoznato polje',
        'Disabled': 'Isključeno',
        'Before': 'Ispred',
        'After': 'Iza',
        'Show Value': 'Prikaži Tablicu',
        'Show Variables and Dimensions': 'Prikaži varijable i dimenzije',
        'Hide Gridlines': 'Sakrij grid',
        'Labels': 'Labele',
        'Name and Description': 'Naziv i opis',
        'Subtotals': 'Totali',
        'Freeze Rows/Columns': 'Zaledi Retke/Stupce',
    },
};
